var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gotop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51932",
    "data-name": "Group 51932",
    transform: "translate(-944.856 -5243.356)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4928",
    "data-name": "Rectangle 4928",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(944.856 5243.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-up",
    "data-name": "Icon awesome-chevron-up",
    d: "M974.866,5265.783l11.572,11.732a1.464,1.464,0,0,1,0,2.05l-1.35,1.369a1.417,1.417,0,0,1-2.018,0l-9.212-9.3-9.215,9.3a1.415,1.415,0,0,1-2.018,0l-1.349-1.371a1.465,1.465,0,0,1,0-2.05l11.571-11.732A1.414,1.414,0,0,1,974.866,5265.783Z",
    transform: "translate(-9 -10.002)",
    fill: "#0A0B1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTop);
export default __webpack_public_path__ + "static/media/go-top.711184fd1260fd26ea72b642fd9f52e3.svg";
export { ForwardRef as ReactComponent };